type BASE_PATHS_PROPS = {
  APP: string;
  AUTH: string;
};

type APP_PATHS_PROPS = {
  SPOTLIGHT: string;
  DASHBOARD: string;
  RADAR_CHECK: string;
  CHECK_HISTORY: string;
  RADAR_RULES: string;
  RADAR_ANALYTICS: string;
  WALLET: string;
  API_KEYS: string;
  DOCUMENTATION: string;
  SETTINGS: string;
  BACK_OFFICE: string;
  TRANSACTION_MONITORING: string;
};

type AUTH_PATHS_PROPS = {
  LOGIN: string;
};

export const BASE_PATHS: BASE_PATHS_PROPS = {
  APP: "app",
  AUTH: process.env.REACT_APP_MAIN_URL,
};

export const AUTH_PATHS: AUTH_PATHS_PROPS = {
  LOGIN: "login",
};

const host = window.location.host;

export const APP_PATHS: APP_PATHS_PROPS = {
  SPOTLIGHT: host === "intel.peleza.com" ? "aml-spotlight" : "radar-spotlight",

  DASHBOARD: "dashboard",

  RADAR_CHECK: host === "intel.peleza.com" ? "aml-check" : "radar-check",

  CHECK_HISTORY: `check-history`,

  RADAR_RULES: host === "intel.peleza.com" ? "aml-rules" : "radar-rules",

  RADAR_ANALYTICS:
    host === "intel.peleza.com" ? "aml-analytics" : "radar-analytics",

  WALLET: "wallet",

  API_KEYS: "configuration",

  DOCUMENTATION: "documentation",

  SETTINGS: "settings",

  BACK_OFFICE: "back-office",

  TRANSACTION_MONITORING: "transaction-monitoring",
};
